import _defineProperty from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/regenerator/index.js";
/* eslint-disable */
import { resolveRequestDocument } from './resolveRequestDocument.js';
import { ClientError } from './types.js';
// import type WebSocket from 'ws'
var CONNECTION_INIT = "connection_init";
var CONNECTION_ACK = "connection_ack";
var PING = "ping";
var PONG = "pong";
var SUBSCRIBE = "subscribe";
var NEXT = "next";
var ERROR = "error";
var COMPLETE = "complete";
var GraphQLWebSocketMessage = /*#__PURE__*/function () {
  function GraphQLWebSocketMessage(type, payload, id) {
    _classCallCheck(this, GraphQLWebSocketMessage);
    this._type = type;
    this._payload = payload;
    this._id = id;
  }
  _createClass(GraphQLWebSocketMessage, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "payload",
    get: function get() {
      return this._payload;
    }
  }, {
    key: "text",
    get: function get() {
      var result = {
        type: this.type
      };
      if (this.id != null && this.id != undefined) result.id = this.id;
      if (this.payload != null && this.payload != undefined) result.payload = this.payload;
      return JSON.stringify(result);
    }
  }], [{
    key: "parse",
    value: function parse(data, f) {
      var _JSON$parse = JSON.parse(data),
        type = _JSON$parse.type,
        payload = _JSON$parse.payload,
        id = _JSON$parse.id;
      return new GraphQLWebSocketMessage(type, f(payload), id);
    }
  }]);
  return GraphQLWebSocketMessage;
}();
var GraphQLWebSocketClient = /*#__PURE__*/function () {
  function GraphQLWebSocketClient(socket, _ref) {
    var _this = this;
    var onInit = _ref.onInit,
      onAcknowledged = _ref.onAcknowledged,
      onPing = _ref.onPing,
      onPong = _ref.onPong;
    _classCallCheck(this, GraphQLWebSocketClient);
    this.socketState = {
      acknowledged: false,
      lastRequestId: 0,
      subscriptions: {}
    };
    this.socket = socket;
    socket.addEventListener("open", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.socketState.acknowledged = false;
                _this.socketState.subscriptions = {};
                _context.t0 = socket;
                _context.t1 = ConnectionInit;
                if (!onInit) {
                  _context.next = 10;
                  break;
                }
                _context.next = 7;
                return onInit();
              case 7:
                _context.t2 = _context.sent;
                _context.next = 11;
                break;
              case 10:
                _context.t2 = null;
              case 11:
                _context.t3 = _context.t2;
                _context.t4 = (0, _context.t1)(_context.t3).text;
                _context.t0.send.call(_context.t0, _context.t4);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    socket.addEventListener("close", function (e) {
      _this.socketState.acknowledged = false;
      _this.socketState.subscriptions = {};
    });
    socket.addEventListener("error", function (e) {
      console.error(e);
    });
    socket.addEventListener("message", function (e) {
      try {
        var message = parseMessage(e.data);
        switch (message.type) {
          case CONNECTION_ACK:
            {
              if (_this.socketState.acknowledged) {
                console.warn("Duplicate CONNECTION_ACK message ignored");
              } else {
                _this.socketState.acknowledged = true;
                if (onAcknowledged) onAcknowledged(message.payload);
              }
              return;
            }
          case PING:
            {
              if (onPing) onPing(message.payload).then(function (r) {
                return socket.send(Pong(r).text);
              });else socket.send(Pong(null).text);
              return;
            }
          case PONG:
            {
              if (onPong) onPong(message.payload);
              return;
            }
        }
        if (!_this.socketState.acknowledged) {
          // Web-socket connection not acknowledged
          return;
        }
        if (message.id === undefined || message.id === null || !_this.socketState.subscriptions[message.id]) {
          // No subscription identifer or subscription indentifier is not found
          return;
        }
        var _this$socketState$sub = _this.socketState.subscriptions[message.id],
          query = _this$socketState$sub.query,
          variables = _this$socketState$sub.variables,
          subscriber = _this$socketState$sub.subscriber;
        switch (message.type) {
          case NEXT:
            {
              if (!message.payload.errors && message.payload.data) {
                subscriber.next && subscriber.next(message.payload.data);
              }
              if (message.payload.errors) {
                subscriber.error && subscriber.error(new ClientError(_objectSpread(_objectSpread({}, message.payload), {}, {
                  status: 200
                }), {
                  query: query,
                  variables: variables
                }));
              } else {}
              return;
            }
          case ERROR:
            {
              subscriber.error && subscriber.error(new ClientError({
                errors: message.payload,
                status: 200
              }, {
                query: query,
                variables: variables
              }));
              return;
            }
          case COMPLETE:
            {
              subscriber.complete && subscriber.complete();
              delete _this.socketState.subscriptions[message.id];
              return;
            }
        }
      } catch (e) {
        // Unexpected errors while handling graphql-ws message
        console.error(e);
        socket.close(1006);
      }
      socket.close(4400, "Unknown graphql-ws message.");
    });
  }
  _createClass(GraphQLWebSocketClient, [{
    key: "makeSubscribe",
    value: function makeSubscribe(query, operationName, subscriber, variables) {
      var _this2 = this;
      var subscriptionId = (this.socketState.lastRequestId++).toString();
      this.socketState.subscriptions[subscriptionId] = {
        query: query,
        variables: variables,
        subscriber: subscriber
      };
      this.socket.send(Subscribe(subscriptionId, {
        query: query,
        operationName: operationName,
        variables: variables
      }).text);
      return function () {
        _this2.socket.send(Complete(subscriptionId).text);
        delete _this2.socketState.subscriptions[subscriptionId];
      };
    }
  }, {
    key: "rawRequest",
    value: function rawRequest(query, variables) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var result;
        _this3.rawSubscribe(query, {
          next: function next(data, extensions) {
            return result = {
              data: data,
              extensions: extensions
            };
          },
          error: reject,
          complete: function complete() {
            return resolve(result);
          }
        }, variables);
      });
    }
  }, {
    key: "request",
    value: function request(document, variables) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var result;
        _this4.subscribe(document, {
          next: function next(data) {
            return result = data;
          },
          error: reject,
          complete: function complete() {
            return resolve(result);
          }
        }, variables);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(document, subscriber, variables) {
      var _resolveRequestDocume = resolveRequestDocument(document),
        query = _resolveRequestDocume.query,
        operationName = _resolveRequestDocume.operationName;
      return this.makeSubscribe(query, operationName, subscriber, variables);
    }
  }, {
    key: "rawSubscribe",
    value: function rawSubscribe(query, subscriber, variables) {
      return this.makeSubscribe(query, undefined, subscriber, variables);
    }
  }, {
    key: "ping",
    value: function ping(payload) {
      this.socket.send(Ping(payload).text);
    }
  }, {
    key: "close",
    value: function close() {
      this.socket.close(1000);
    }
  }]);
  return GraphQLWebSocketClient;
}();
GraphQLWebSocketClient.PROTOCOL = "graphql-transport-ws";
export { GraphQLWebSocketClient };
// Helper functions
function parseMessage(data) {
  var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a) {
    return a;
  };
  var m = GraphQLWebSocketMessage.parse(data, f);
  return m;
}
function ConnectionInit(payload) {
  return new GraphQLWebSocketMessage(CONNECTION_INIT, payload);
}
function Ping(payload) {
  return new GraphQLWebSocketMessage(PING, payload, undefined);
}
function Pong(payload) {
  return new GraphQLWebSocketMessage(PONG, payload, undefined);
}
function Subscribe(id, payload) {
  return new GraphQLWebSocketMessage(SUBSCRIBE, payload, id);
}
function Complete(id) {
  return new GraphQLWebSocketMessage(COMPLETE, undefined, id);
}